import type { ObjectStoreMeta } from 'ngx-indexed-db';
export const DbConfig = {
  name: 'appDataDB',
  version: 1,
  objectStoresMeta: [
    {
      store: 'appData',
      storeConfig: { keyPath: 'key', autoIncrement: false },
      storeSchema: [] as ObjectStoreMeta['storeSchema'],
    },
  ],
};
